import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

/**
 * Einheitliche KPI-Karte (Styleguide Juni 2026):
 * flach, 1px Rahmen, 8px Radius, Hover-Lift, Monospace-Wert.
 * Farbe nur als Funktion (valueClassName/iconColor) — keine farbigen Top-Border mehr.
 */
export function KPICard({ title, value, subtitle, trend, icon: Icon, iconColor = 'bg-slate-100 text-slate-500', valueClassName = 'text-slate-900', testId }) {
  return (
    <Card
      className="rounded-lg border border-slate-200 shadow-none transition-all duration-200 hover:-translate-y-1 hover:border-slate-300 hover:shadow-md"
      data-testid={testId}
    >
      <CardContent className="p-5 sm:p-6">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0 space-y-1">
            <p className="text-xs font-medium uppercase tracking-[0.05em] text-slate-500">{title}</p>
            <p className={`truncate text-3xl sm:text-4xl font-semibold font-mono tracking-tight ${valueClassName}`}>{value}</p>
            {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
          </div>
          {(Icon || trend) && (
            <div className="flex flex-col items-end gap-2">
              {Icon && (
                <div className={`rounded-lg p-2.5 ${iconColor}`}>
                  <Icon className="h-5 w-5" />
                </div>
              )}
              {trend}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
